import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-3348">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-3349">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-3350" />
        <div className="flex gap-2" data-id="element-3351">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-3352" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-3353" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3354">
        <div className="space-y-6" data-id="element-3355">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-3356">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-3357" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3358">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-3359">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-3360" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-3361" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-3362">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-3363" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-3364" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-3365">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-3366" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-3367" />
          </div>
        </div>
      </div>
    </div>;
}